export function PersonalRelationshipsDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Personal Relationship Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Event Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Type of Event <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select event type</option>
              <option value="first_meeting">First Meeting</option>
              <option value="first_date">First Date</option>
              <option value="engagement">Engagement</option>
              <option value="moving_in">Moving In Together</option>
              <option value="commitment">Commitment Ceremony</option>
            </select>
          </div>

          {/* Partner's Name */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Partner's Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter partner's name"
            />
          </div>

          {/* Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* Place/Venue */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Place/Venue
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter specific place or venue"
            />
          </div>

          {/* Relationship Status */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Relationship Status
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select status</option>
              <option value="dating">Dating</option>
              <option value="engaged">Engaged</option>
              <option value="committed">Committed</option>
              <option value="married">Married</option>
            </select>
          </div>

          {/* Special Details */}
          <div className="col-span-2 space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Special Details
            </label>
            <textarea
              className="w-full h-32 p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Share any special details about this moment"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 